<script>
  import Blank from '../story/Blank.svelte'
  import Introduction from '../story/Introduction.svelte'
  import One from '../story/One.svelte'
  import Two from '../story/Two.svelte'
  import Three from '../story/Three.svelte'
  import Four from '../story/Four.svelte'
  import Five from '../story/Five.svelte'
  import Six from '../story/Six.svelte'
  import Seven from '../story/Seven.svelte'
  import Eight from '../story/Eight.svelte'
  import Nine from '../story/Nine.svelte'
  import Ten from '../story/Ten.svelte'
  import End from '../story/End.svelte'

  import { fade } from 'svelte/transition'
  import { fly } from 'svelte/transition'


  let buttonText = 'MOVE';
  let xta = 0;

  let audio0 = new Audio('audio/0.wav');
  let audio1 = new Audio('audio/1.wav');
  let audio2 = new Audio('audio/2.wav');
  let audio3 = new Audio('audio/3.wav');
  let audio4 = new Audio('audio/4.wav');
  let audio5 = new Audio('audio/5.wav');
  let audio6 = new Audio('audio/6.wav');
  let audio7 = new Audio('audio/7.wav');
  let audio8 = new Audio('audio/8.wav');
  let audio9 = new Audio('audio/9.wav');
  let audio10 = new Audio('audio/10.wav');
  let audio11 = new Audio('audio/11.wav');
  let audio12 = new Audio('audio/12.wav');

  let arr = [
    Introduction,
    One,
    Two,
    Three,
    Four,
    Five,
    Six,
    Seven,
    Eight,
    Nine,
    Blank,
    Ten,
    End
  ]

  let audioarr = [
    audio0,
    audio1,
    audio2,
    audio3,
    audio4,
    audio5,
    audio6,
    audio7,
    audio8,
    audio9,
    audio10,
    audio11,
    audio12
  ];

  function changeText() {
    buttonText = 'MOVE'
    xta +=1;
    audioarr[Math.floor(Math.random() * audioarr.length)].play();
    if (xta == 3) {
      buttonText='be careful - the demons will tell you to stop'
    }
    if (xta == 4) {
      buttonText='please - dont stop for anything'
    }
    if (xta ==5) {
      buttonText='promise me you wont stop'
    }
    if (xta == 6) {
      buttonText='STOP'
      alert('you have to stop\ndont look any further\nthere\'s nothing here for you')
    }
    if (xta == 7) {
      buttonText='REPLY?'
    }
    if (xta == 8) {
      buttonText='Log in'
    }
    if (xta == 9 ) {
      buttonText='your non-compliance has been noted. you are now on a watchlist. you are unredeemable'
    }
    if (xta == 11) {
      buttonText=' '
      setTimeout(special, 30000);
    }
    if(xta == arr.length -1){
      buttonText = ' ';
      xta+-1;
    }
  }

  function special() {
    xta += 1;
  }
</script>

<style>
  .alignment-box {
    position: relative;
    width: 70%;
    align-items: flex-start;
    padding-top: 50px;
  }

  button {
    position: absolute;
    top: 50px;
		background-color: transparent;
		color: white;
		border: none;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 0px;
    padding-right: 0px;
		text-transform: uppercase;
    font-family: monospace;
    cursor: crosshair;
		z-index: 10;
	}

  .buttonsbox {
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:9;
  }

  .large {
    position: relative;
    font-size: 100px;
    font-family: serif;
  }

	:global(body.dark-mode) button {
		background-color: transparent;
		color: black;
	}

  .reply {
    position: relative;
    height: 200px;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
  }

  .login {
    position: relative;
    font-family: Arial, Helvetica, sans-serif;
    padding: 10px;
    border-radius: 5px;
    background-color: darkblue;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 18px;
    color: white;
  }

  :global(body.dark-mode) .login {
    background-color: skyblue;
    color: white;
  }

  .spacer{
    height: 200px;
  }
</style>

<div class='alignment-box'>
  {#if (xta == 5)}
    <svelte:component this={arr[xta]}/>
    <div class='buttonsbox' transition:fade>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
      <button on:click={changeText} class = 'large'>{buttonText}</button>
    </div>
  {:else if (xta == 7)}
    <svelte:component this={arr[xta]}/>
    <button on:click={changeText} class='reply'>{buttonText}</button>
  {:else if (xta == 8)}
    <svelte:component this={arr[xta]}/>
    <button on:click={changeText} class='login' transition:fly>{buttonText}</button>
    <div class='spacer'></div>
  {:else if (xta == 9)}
    <svelte:component this={arr[xta]}/>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <div class='spacer'></div>
    <button on:click={changeText} class='reply'>{buttonText}</button>
    <div class='spacer'></div>
  {:else}
  <button on:click={changeText}>{buttonText}</button>
    <svelte:component this={arr[xta]}/>
  {/if}
</div>
